"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockFolders = void 0;
var DashboardTypes_1 = require("@CommonFrontendBackend/Dashboard/DashboardTypes");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var DashboardUtils_1 = require("Dashboard/DashboardUtils");
var Sidebar_1 = require("Dashboard/Sidebar/Sidebar");
var react_1 = __importDefault(require("react"));
var FolderHeading_1 = require("../Folders/FolderHeading");
var mobx_react_1 = require("mobx-react");
var BlockFolders = (function (_super) {
    __extends(BlockFolders, _super);
    function BlockFolders() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSelectFolder = function (id) {
            var _a = _this.props, savedBlocksFolderViewStore = _a.savedBlocksFolderViewStore, savedBlockViewStore = _a.savedBlockViewStore;
            savedBlocksFolderViewStore.folderSelectionStore.setSelectedFolder(id);
            savedBlockViewStore.filterSavedBlocksByFolderId(id);
        };
        return _this;
    }
    BlockFolders.prototype.render = function () {
        var closeFoldersSlot = this.props.closeFoldersSlot;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(FolderHeading_1.FolderHeading, { text: "Account folders", actions: closeFoldersSlot }),
            react_1.default.createElement("div", { className: "space-stack-l" },
                react_1.default.createElement(kaleidoscope_1.FolderTree, { disableOptions: true, viewStore: this.props.savedBlocksFolderViewStore.accountFolderViewStore, onSelect: this.onSelectFolder })),
            react_1.default.createElement(Sidebar_1.SystemFolder, { dragDropOnFolder: function () { }, name: (0, DashboardUtils_1.getBlockFolderTitle)(DashboardTypes_1.SavedBlockCollection.All), collection: DashboardTypes_1.SavedBlockCollection.All, onFolderSelect: this.onSelectFolder, active: this.props.savedBlocksFolderViewStore.folderSelectionStore.selectedFolder === DashboardTypes_1.SavedBlockCollection.All, icon: react_1.default.createElement(icons_1.Folder, null) })));
    };
    BlockFolders = __decorate([
        mobx_react_1.observer
    ], BlockFolders);
    return BlockFolders;
}(react_1.default.Component));
exports.BlockFolders = BlockFolders;
